import React, { useContext } from 'react';
import { RulerContext } from '../../contexts/RulerContext';
import { toDist } from './HorizontalRuler';

const serifWidth = 20;


export function VerticalRuler(props:{
    x: number;
    y: number;
    length: number;
}) {
    const {
        x,
        y,
        length
    } = props;
    const {
        stroke,
        fontSize
    } = useContext(RulerContext);

    var y2 = y + length;

    return (
        <g className="vertical-ruler ruler">
            <line className="ruler-main-line" x1={x} x2={x} y1={y} y2={y2} stroke={stroke} />
            <line className="ruler-serif" x1={x + serifWidth} x2={x - serifWidth} y1={y} y2={y} stroke={stroke} />
            <line className="ruler-serif" x1={x + serifWidth} x2={x - serifWidth} y1={y2} y2={y2} stroke={stroke} />
            <text className="ruler-text"
                x={0}
                y={0}
                textAnchor="middle"
                transform={`translate( ${x-6} ${(y + y2) / 2} ) rotate(270)`}
                fontSize={fontSize}>
                {toDist(length)}
            </text>
        </g>
	);
}

export module VerticalRuler {
    export const width = serifWidth * 2 + 60;
}
